import { ROUTE_RISK_TREND } from '@/constants/routes';
import setTitleFromLoader from '@/utils/routing/set-title';
import { RouteObject } from 'react-router-dom';
import Page from './risk-trend.page';

export const routeRiskTrend: RouteObject = {
  path: ROUTE_RISK_TREND,
  Component: Page,
  loader: setTitleFromLoader('Risk Trend'),
};
